import React from 'react';
import { MemoryRouter, Route, Switch } from 'react-router-dom';
import { StateMachineProvider } from 'little-state-machine';

import Layout from '../../components/Layout';

import Data from './01-data';
import Offers from './02-offers';
// import Contact from './03-contact';

const Consumo = () => (
  <StateMachineProvider>
    <MemoryRouter initialEntries={['/1', '/2', '/3']} initialIndex={0}>
      <Layout>
        <Switch>
          <Route exact path="/1" component={Data} />
          <Route exact path="/2" component={Offers} />
          {/* <Route exact path="/3" component={Contact} /> */}
        </Switch>
      </Layout>
    </MemoryRouter>
  </StateMachineProvider>
);

export default Consumo;
